/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  delete(id, replacementLabelId) {
    if (!replacementLabelId) return super.delete(id);

    return axios.delete(`${this.url}/${id}`, {
      params: { replacement_label_id: replacementLabelId },
    });
  }
}

export default new LabelsAPI();
